import { createUseStyles } from 'react-jss'

export const style = {
  feature: {
    stroke: 'white',
    strokeWidth: 1
  },
  featureWithoutOutline: {
    extend: 'feature',
    strokeWidth: 0
  },
  selected: {
    stroke: 'black'
  },
  disableMouseEvents: {
    pointerEvents: 'none'
  },
  zoomedLayer: {
    strokeWidth: 0.3,
    strokeDasharray: 0.5
  }
}

export const useStyles = createUseStyles(style)
